// named imports/exports must use curly brackets (can't indirectly import React Hooks)
import React, {useState, useEffect, useRef} from 'react'; 
// import React from 'react'; // use React features
import ReactDOM from 'react-dom/client'; // used to run the React app
//import useState from 'react';
// import './index.css';

// required to use './' when importing a JS file ('.js' right after the file name is optional)
import App from './App';

// import reportWebVitals from './reportWebVitals';
const myFirstElement = <h1>Hello React!</h1>;

// create the root node, which is the foundation of the React App
const root = ReactDOM.createRoot(document.getElementById('root'));



// forms

// displays the root onto the web app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// React.StrictMode is kinda like "debug" mode

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
